class s {
  constructor(t, e) {
    this.state = t, this.ignoreSet = new Set(e?.ignoreUnknownAttributes ?? []);
  }
  ignoreSet;
  setName(t, e) {
    this.state.setEntityName(t, e);
  }
  getEntityByName(t) {
    return this.state.getEntityByName(t);
  }
  shouldIgnoreUnknownAttribute(t) {
    return this.ignoreSet.has(t);
  }
}
export {
  s as ParseContext
};
//# sourceMappingURL=parse-context.js.map
